import React from "react";
import { HashLink } from "react-router-hash-link";
import { getLang } from "../../features/app/appSlice";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Logo from "../../components/Logo/Logo";
import { companyLogo, companyLogoOriginal } from "../../assets/imgExport";
import "./Footer.module.scss";
function Footer(props: any) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("submitted");
  };

  return (
    <footer
      className={`mt-auto border-t p-10  text-white bg-main flex flex-col gap-20`}
    >
      <div className="flex gap-10 flex-col sm:flex-row">
        <div className="w-full flex flex-col items-start">
          <img
            className="w-36"
            src={companyLogoOriginal}
            alt="Venti Maris company logo"
          />
          {/* <p>Stay updated on the latest offshore wind transport innovations</p>
          <form onSubmit={handleSubmit} className="text-sm">
            <input
              className="border  border-black font-light px-4 py-2 bg-transparent"
              type="email"
              placeholder="Email address"
            />
            <button
              className="inline-block border text-black border-black px-4 py-2 bg-transparent"
              type="submit"
              style={{
                border: "1px solid black",
                marginLeft: "10px",
                fontSize: "0.75rem",
              }}
            >
              Subscribe
            </button>
          </form>
          <p className="text-xs mt-2">
            By subscribing, you agree to our privacy policy and consent to
            receive updates.
          </p> */}
        </div>
        <div className="flex gap-16 text-nowrap text-black font-light text-xs">
          <div className="flex flex-col gap-6 mr-10">
            <p className="font-bold">Company</p>
            <NavLink to="/about-us">About us</NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/careers">Careers</NavLink>
            <NavLink to="/contact">Contact us</NavLink>
          </div>
          {/* <div className="flex flex-col gap-6">
            <p className="font-bold">Follow us</p>
            <NavLink to="/">LinkedIn</NavLink>
          </div> */}
        </div>
      </div>
      <div className="w-full border-t border-black flex gap-4 justify-between items-start sm:items-center flex-col sm:flex-row">
        <div>
          <p className="my-0 mt-2">
            &copy; {new Date().getFullYear()} Venti Maris. All rights reserved.
          </p>
          <p className="text-xs text-black/30 my-0">
            VENTI MARIS LIMITED, registered in Scotland, Company Number 849197
          </p>
        </div>
        <ul className="flex gap-4  border-b-[0.5px] border-white/10 justify-center text-black/70">
          <li>
            <NavLink to="/policies/terms" target="_blank">
              Terms of use
            </NavLink>
          </li>

          <li>
            <NavLink to="/policies/privacy" target="_blank">
              Privacy Policy
            </NavLink>
          </li>
          <li>
            <NavLink to="/policies/cookies" target="_blank">
              Cookie Policy
            </NavLink>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
